import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _30894435 = () => interopDefault(import('../_templates/pages/blog/Blog.vue' /* webpackChunkName: "" */))
const _11a91f96 = () => interopDefault(import('../_templates/pages/checkout/Checkout.vue' /* webpackChunkName: "" */))
const _06e9c958 = () => interopDefault(import('../_templates/pages/checkout/Checkout/Order.vue' /* webpackChunkName: "" */))
const _17963333 = () => interopDefault(import('../_templates/pages/checkout/Checkout/Account.vue' /* webpackChunkName: "" */))
const _6e909dbf = () => interopDefault(import('../_templates/pages/checkout/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _167d3de8 = () => interopDefault(import('../_templates/pages/customer/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _596db70c = () => interopDefault(import('../_templates/pages/customer/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _12aa6e76 = () => interopDefault(import('../_templates/pages/customer/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _10c4b4ba = () => interopDefault(import('../_templates/pages/customer/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _3f1cccc6 = () => interopDefault(import('../_templates/pages/customer/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _96fc4658 = () => interopDefault(import('../_templates/pages/customer/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _36aa65f9 = () => interopDefault(import('../_templates/pages/customer/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _3079cc4f = () => interopDefault(import('../_templates/pages/theme/Home.vue' /* webpackChunkName: "" */))
const _b4b5e1ba = () => interopDefault(import('../_templates/pages/faq/Faq.vue' /* webpackChunkName: "" */))
const _7bbd7335 = () => interopDefault(import('../_templates/pages/search/Search.vue' /* webpackChunkName: "" */))
const _30b47596 = () => interopDefault(import('../_templates/pages/customer/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _47624b16 = () => interopDefault(import('../_templates/pages/blog/BlogPost.vue' /* webpackChunkName: "" */))
const _5fb9ab64 = () => interopDefault(import('../_templates/pages/attribute-collection/AttributeCollection.vue' /* webpackChunkName: "" */))
const _8acaf9d2 = () => interopDefault(import('../_templates/pages/attribute-collection/AttributeCollectionItem.vue' /* webpackChunkName: "" */))
const _fea23c02 = () => interopDefault(import('../_templates/pages/theme/Page.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aktuelt",
    component: _30894435,
    name: "blog___default___default"
  }, {
    path: "/checkout",
    component: _11a91f96,
    name: "checkout___default___default",
    children: [{
      path: "bestilling",
      component: _06e9c958,
      name: "checkout-order___default___default"
    }, {
      path: "konto",
      component: _17963333,
      name: "checkout-account___default___default"
    }, {
      path: "takk",
      component: _6e909dbf,
      name: "checkout-thank-you___default___default"
    }]
  }, {
    path: "/customer",
    component: _167d3de8,
    meta: {"titleLabel":"Account"},
    name: "customer___default___default",
    children: [{
      path: "addresses-details",
      component: _596db70c,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___default___default"
    }, {
      path: "my-profile",
      component: _12aa6e76,
      meta: {"titleLabel":"My Account"},
      name: "customer-my-profile___default___default"
    }, {
      path: "order-history",
      component: _10c4b4ba,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___default___default"
    }, {
      path: "addresses-details/create",
      component: _3f1cccc6,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___default___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _96fc4658,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___default___default"
    }, {
      path: "order-history/:orderId",
      component: _36aa65f9,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___default___default"
    }]
  }, {
    path: "/default",
    component: _3079cc4f,
    name: "home___default"
  }, {
    path: "/faq.html",
    component: _b4b5e1ba,
    name: "faq___default___default"
  }, {
    path: "/search",
    component: _7bbd7335,
    name: "search___default___default"
  }, {
    path: "/customer/reset-password",
    component: _30b47596,
    alias: "/customer/account/createPassword",
    name: "reset-password___default___default"
  }, {
    path: "/default/aktuelt",
    component: _30894435,
    name: "blog___default"
  }, {
    path: "/default/checkout",
    component: _11a91f96,
    name: "checkout___default",
    children: [{
      path: "bestilling",
      component: _06e9c958,
      name: "checkout-order___default"
    }, {
      path: "konto",
      component: _17963333,
      name: "checkout-account___default"
    }, {
      path: "takk",
      component: _6e909dbf,
      name: "checkout-thank-you___default"
    }]
  }, {
    path: "/default/customer",
    component: _167d3de8,
    meta: {"titleLabel":"Account"},
    name: "customer___default",
    children: [{
      path: "addresses-details",
      component: _596db70c,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___default"
    }, {
      path: "my-profile",
      component: _12aa6e76,
      meta: {"titleLabel":"My Account"},
      name: "customer-my-profile___default"
    }, {
      path: "order-history",
      component: _10c4b4ba,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___default"
    }, {
      path: "addresses-details/create",
      component: _3f1cccc6,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _96fc4658,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___default"
    }, {
      path: "order-history/:orderId",
      component: _36aa65f9,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___default"
    }]
  }, {
    path: "/default/faq.html",
    component: _b4b5e1ba,
    name: "faq___default"
  }, {
    path: "/default/search",
    component: _7bbd7335,
    name: "search___default"
  }, {
    path: "/default/customer/reset-password",
    component: _30b47596,
    alias: "/customer/account/createPassword",
    name: "reset-password___default"
  }, {
    path: "/default/aktuelt/:slug+",
    component: _47624b16,
    name: "blogPost___default"
  }, {
    path: "/default/collection/:slug([^/.]+).html",
    component: _5fb9ab64,
    name: "attributeCollection___default"
  }, {
    path: "/default/collection/:collection_slug/:slug+.html",
    component: _8acaf9d2,
    name: "attributeCollectionItem___default"
  }, {
    path: "/aktuelt/:slug+",
    component: _47624b16,
    name: "blogPost___default___default"
  }, {
    path: "/default/:slug+",
    component: _fea23c02,
    name: "page___default"
  }, {
    path: "/collection/:slug([^/.]+).html",
    component: _5fb9ab64,
    name: "attributeCollection___default___default"
  }, {
    path: "/collection/:collection_slug/:slug+.html",
    component: _8acaf9d2,
    name: "attributeCollectionItem___default___default"
  }, {
    path: "/",
    component: _3079cc4f,
    name: "home___default___default"
  }, {
    path: "/:slug+",
    component: _fea23c02,
    name: "page___default___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
